import { render, staticRenderFns } from "./ClassifiedsList.vue?vue&type=template&id=f4466ea2&"
import script from "./ClassifiedsList.vue?vue&type=script&lang=ts&"
export * from "./ClassifiedsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports